import type { EthereumAddress } from "@bracket/types";

export const address: EthereumAddress = "0xfCa2b37CC2F2031B1FACdE1bE2fA34A0159c7697";

export const abi = [
	{
		inputs: [],
		name: "delta",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256",
			},
		],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "asset",
				type: "address",
			},
		],
		name: "getClaimPrice",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256",
			},
		],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "asset",
				type: "address",
			},
		],
		name: "getLatestPrice",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256",
			},
		],
		stateMutability: "view",
		type: "function",
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "_delta",
				type: "int256",
			},
		],
		name: "setClaimDelta",
		outputs: [],
		stateMutability: "nonpayable",
		type: "function",
	},
] as const;
